/* tslint:disable */
/* eslint-disable */
/**
 * Jack Burton Internal API
 * API for the Jack Burton platform
 *
 * The version of the OpenAPI document: v1 App
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const PermissionResource = {
    Integration: 'Integration',
    Config: 'Config',
    Contact: 'Contact',
    Customer: 'Customer',
    Qa: 'QA',
    Scorecard: 'Scorecard',
    ScorecardTemplate: 'ScorecardTemplate',
    Demo: 'Demo',
    QaConfig: 'QAConfig',
    Task: 'Task',
    TenantConfig: 'TenantConfig',
    User: 'User',
    Team: 'Team'
} as const;
export type PermissionResource = typeof PermissionResource[keyof typeof PermissionResource];


export function PermissionResourceFromJSON(json: any): PermissionResource {
    return PermissionResourceFromJSONTyped(json, false);
}

export function PermissionResourceFromJSONTyped(json: any, ignoreDiscriminator: boolean): PermissionResource {
    return json as PermissionResource;
}

export function PermissionResourceToJSON(value?: PermissionResource | null): any {
    return value as any;
}

